export default __webpack_public_path__ + "static/media/MemcheckBeginImg.dd1b0daf.svg";